<template>
  <el-main>
    <div class="projects-list panel list-panel"
         v-for="(projects, key) in projectsFiltered"
         :key="key">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><b>{{ key }}</b></span>
        </div>
        <div class="list-group">
          <el-button plain class="project-list-item list-item"
                     v-for="project in projects"
                     :key="project.id"
                     @click="gotoProject(project)"
          >
            <div class="list-item-btn">
              <client-code v-if="!project.client_icon_url" :code="project.client_code" :seed="project.client_name" />
              <img v-if="project.client_icon_url" :src="project.client_icon_url" class="client-code"/>
              <div class="info">
                <div class="title"><b>{{ project.name }}</b></div>
                <div class="code">{{ project.project_code }} - {{ project.client_name }}</div>
                <div class="created-at">Created {{ project.created_at | localiseUTCDate }} by {{ project.user_full_name }}</div>
              </div>
              <!--
              <project-hours-tags v-if="windowWidth >= 1300"
                                  :project="project"
                                  :size="projectHoursTagsSize" />
              -->
              <project-avatars :project="project" :shorten="true" />

              <el-tag class="status"
                      :size="projectHoursTagsSize"
                      :type="project.status ? 'success' : 'danger'"
                      v-if="!isAdmin"
              >{{ project.status ? 'Open' : 'Closed' }}</el-tag>
              <div class="status status-toggle"
                   v-if="isAdmin"
                   @click.stop.prevent="updateStatus(project)">
                <el-switch
                  v-model="project.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                >
                </el-switch>
              </div>

              <i class="el-icon-caret-right icon"></i>
            </div>
            <!--
            <project-hours-tags v-if="windowWidth < 1300"
                                :project="project"
                                :size="projectHoursTagsSize" />
                                -->
          </el-button>
        </div>
      </el-card>
    </div>
    <el-card class="box-card" v-if="!Object.keys(projectsFiltered).length">
      <div slot="header" class="clearfix">
        <span><b>No Projects Found!</b></span>
      </div>
    </el-card>
  </el-main>

</template>

<script>
  import moment from 'moment'
  import { mixin as Utils } from '../../mixins/Utils'
  export default {
    name: 'project-list',
    mixins: [Utils],
    props: {
      searchTerm: {
        default: ''
      },
      projects: {
        default: []
      }
    },
    data () {
      return {
        windowWidth: 0
      }
    },
    methods: {
      getWindowWidth () {
        this.windowWidth = document.documentElement.clientWidth
      },
      gotoProject (project) {
        this.$router.push({name: 'project', params: { project_id: project.id }})
      },
      updateStatus (project) {
        // Note that Vue Element will have already changed the Status
        if (project.status) {
          this.$confirm('Are you sure you want to reopen ' + project.name + '?')
          .then(() => {
            this.$store.dispatch('updateProject', project)
          })
          .catch(() => {
            project.status = false
          })
        } else {
          this.$store.dispatch('updateProject', project)
        }
      }
    },
    computed: {
      projectHoursTagsSize () {
        return this.windowWidth < 1090 ? 'small' : 'medium'
      },
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      projectsFiltered () {

        // First filter the projects by the search param
        let projects = this.projects.filter((project) => {
          if (this.searchTerm !== '') {
            if (project.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
              project.project_code.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
              project.client_name.toLowerCase().includes(this.searchTerm.toLowerCase())) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        })

        // Now group the results into 'sort by' categories..
        let optionsObj = {}

        let groupBy = this.$store.state.filters.projectsGroupBy // Store will be updated via vuex in watcher
        let typeFilter = this.$store.state.filters.projectsTypeFilter // Store will be updated via vuex in watcher
        let statusFilter = this.$store.state.filters.projectsStatusFilter // Store will be updated via vuex in watcher
        let showProspect = typeFilter.indexOf('prospect') !== -1
        let showAccepted = typeFilter.indexOf('approved') !== -1
        let showOpen = statusFilter.indexOf('active') !== -1
        let showClosed = statusFilter.indexOf('inactive') !== -1


        // Group Projects by the select sort type
        Object.keys(projects)
        .map((k) => projects[k])
        .sort((a, b) => {
          if (groupBy === 'A-Z') {
            return a.name > b.name ? 1 : -1
          } else if (groupBy === 'Client Name') {
            return a.client_name > b.client_name ? 1 : -1
          } else {
            // Default - Created At
            return a.created_at > b.created_at ? -1 : 1
          }
        })
        .map((item) => {
          // Filter out items depending on the Status Filter
          if (
              ((!showOpen && !showClosed) || (showOpen && item.status) || (showClosed && !item.status)) &&
              ((!showProspect && !showAccepted) || (showProspect && item.prospect) || (showAccepted && !item.prospect))
          ) {
            let groupLabel = null
            if (groupBy === 'A-Z') {
              groupLabel = item.name.substring(0, 1).toUpperCase()
            } else if (groupBy === 'Client Name') {
              groupLabel = item.client_name
            } else {
              // Default - Created At
              groupLabel = moment(item.created_at).format('MMM YYYY')
            }

            // Dimension the array if it does not yet exist
            if (!optionsObj.hasOwnProperty(groupLabel)) {
              optionsObj[groupLabel] = []
            }
            optionsObj[groupLabel].push(item)
          }
        })
        // Finally, sort the sub groups by title
        for (let groupLabel in optionsObj) {
          optionsObj[groupLabel] = optionsObj[groupLabel].sort((a, b) => {
            if (groupBy === 'A-Z') {
              return a.name > b.name ? 1 : -1
            } else {
              return a.created_at > b.created_at ? -1 : 1
            }
          })
        }
        return optionsObj
      }
    },
    mounted () {
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth)
        this.getWindowWidth()
      })
    }
  }
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .list-item-btn {
    .avatars {
      text-align: right;
      margin-right: 10px;
    }
  }
  .project-hours-tags {
    text-align: left;
    margin-top: 10px;
  }
  .project-hours-tags,
  .el-tag.status {
    margin-right: 10px;
  }
  .status-toggle {
    padding: 10px;
  }
  @media screen and (max-width: 850px) {
    .project-hours-tags {
      display: none;
    }
  }
</style>
